import React, { useState } from "react";

function ReadMoreLess({ data, charLimit = 100 }: any) {
  const [isShowMore, setIsShowMore] = useState(false);
  const toggleReadMoreLess = () => {
    setIsShowMore(!isShowMore);
  };

  // Check if content exceeds the character limit
  const shouldShowButton = data && data.length > charLimit;

  return (
    <div className="card">
      {!isShowMore && shouldShowButton && `${data.substr(0, charLimit)}...`}
      {!isShowMore && !shouldShowButton && data}
      {isShowMore && data}

      {shouldShowButton && (
        <button onClick={toggleReadMoreLess} className="ml-5 link-btn">
          {isShowMore ? "Read Less" : "Read More"}
        </button>
      )}
    </div>
  );
}

export default ReadMoreLess;
